import flatten from "lodash/flatten";

const getTableColumns = (children: any) => {
  const childrenArray = Array.isArray(children) ? children : [children];
  
  const flattenColumns = flatten(childrenArray).map(
    (column: React.ReactElement) => {
      // If the column is a group, we need to get the columns from the children.
      //TODO

      return column;
    }
  );

  // Flatten the array in Columns into a one-dimensional array, and calculate lastColumn and firstColumn.
  return flatten(flattenColumns).filter(Boolean);
};

export default getTableColumns;
